import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import OrderFilter from '@components/search/positionFilter/filter/OrderFilter';
import JobTitlesFilter from '@components/search/positionFilter/filter/JobTitlesFilter';
import RecruitmentFilter from '@components/search/positionFilter/filter/RecruitmentFilter';
import LocationFilter from '@components/search/positionFilter/filter/LocationFilter';
import MatchingStatusFilter from '@components/search/positionFilter/filter/MatchingStatusFilter';
import SalaryFilter from '@components/search/positionFilter/filter/SalaryFilter';
import PositionListFilterVO from '@domain/vo/search/PositionListFilterVO';
import { queryClient } from '@utils/queryClient';

import classnames from 'classnames/bind';
import styles from './positionFilter.module.scss';
const cx = classnames.bind(styles);

const PositionFilter: FC = () => {
  const { reset } = useFormContext<PositionListFilterVO>();

  const onInitFilter = () => {
    reset(new PositionListFilterVO(undefined));
    //필터 초기화 할때마다 재조회하긴 위함
    queryClient.refetchQueries(['search', 'position', 'list'], { active: true });
  };

  return (
    <div className={cx('filterArea')}>
      <div className={cx('filterWrap')}>
        <OrderFilter />
      </div>

      <div className={cx('filterWrap')}>
        <JobTitlesFilter />
        <RecruitmentFilter />
        <SalaryFilter />
        <LocationFilter />
        <MatchingStatusFilter />

        <a className={cx('btnReset')} role="button" onClick={onInitFilter}>
          필터초기화
        </a>
      </div>
    </div>
  );
};

export default PositionFilter;
